import { GeoJSON as OlGeoJSON } from 'ol/format';
import { GeoJSON } from '@vendor/libs/maps/geojson/GeoJSON';
import { toLonLat } from 'ol/proj';
import * as turf from 'turf';
/**
 * @class MapUtils  map utility functions
 */
const MapUtils = {
    featureToGeojson: (feature) => {
        let geojson = new OlGeoJSON();
        const geojsonObject = JSON.parse(geojson.writeFeature(feature, {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857',
        }));
        return {
            ...geojsonObject,
            bbox: turf.bbox(geojsonObject),
        };
    },
    featuresToGeojson: (features) => {
        let geojson = new OlGeoJSON();
        const geojsonObject = JSON.parse(geojson.writeFeatures(features, {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857',
        }));
        return {
            ...geojsonObject,
            bbox: turf.bbox(geojsonObject),
        };
    },
    geojsonToFeature: (geojson) => {
        return new OlGeoJSON().readFeature(geojson, {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857',
        });
    },
    toLonLat: (coordinates) => {
        if (typeof coordinates[0] === 'number' &&
            typeof coordinates[1] === 'number') {
            return toLonLat(coordinates);
        }
        else {
            return coordinates.map(MapUtils.toLonLat);
        }
    },
    geojsonFromAny: (geojson, transformCoordinates = false) => {
        let object = null;
        if (typeof geojson == 'string') {
            // from string
            object = GeoJSON.createFromGeoJSONString(geojson);
        }
        else if (typeof geojson == 'object' &&
            typeof geojson.ol_uid != 'undefined') {
            // from OL feature
            object = GeoJSON.create(MapUtils.featureToGeojson(geojson));
        }
        else if (typeof geojson == 'object' && Array.isArray(geojson)) {
            let coordinates = transformCoordinates
                ? MapUtils.toLonLat(geojson)
                : geojson;
            if (geojson.length === 2 &&
                typeof geojson[0] == 'number' &&
                typeof geojson[1] == 'number') {
                // point
                object = GeoJSON.create({
                    type: 'Point',
                    geometry: {
                        coordinates,
                    },
                });
            }
            else if (typeof geojson[0] == 'object' &&
                typeof geojson[0][0] == 'number' &&
                typeof geojson[0][1] == 'number') {
                // linestring
                object = GeoJSON.create({
                    type: 'LineString',
                    geometry: {
                        coordinates,
                    },
                });
            }
        }
        else {
            object = GeoJSON.create(geojson);
        }
        if (!object) {
            throw new Error('Could not create GeoJSON object');
        }
        if ((typeof object.bbox == 'undefined' || object.bbox == null) &&
            typeof object.geometry != 'undefined') {
            object.bbox = turf.bbox(object);
        }
        return object;
    },
};
export default MapUtils;
